/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


/*------------------------------------------------------------------------------------------------------------
custom js of the country code select on the dropdown of the register form by the cusotmer login of 11-02-2023
-------------------------------------------------------------------------------------------------------------*/

/* $(document).ready(function(){
  $('select.custom_phone_country_code').change(function(){
    //alert('hello');
    var option_data = $(this).val();
     $("#custom_phone_number").keyup(function() {
    var text =$(this).val();
       $("#phone_number").val(option_data +text);
  });
  });
}); */

function changeScreenProtector(element) {
  if (element.hasAttribute("product-id")) {
    document.querySelector(".custom-product-quantity").value = 1;
    document.querySelector(".custom-product-id").value = element.getAttribute("product-id");
  } else {
    document.querySelector(".custom-product-quantity").value = 0;
  }
}

function chooseScreenProtector(element) {
  var currentScreenShield = ".shield-product-quantity-" + element.getAttribute('product-id');
  if (element.checked) {   
    document.querySelector("" + currentScreenShield + "").value = 1;
  } else {
    document.querySelector("" + currentScreenShield + "").value = 0;
  }
}


function showProShockDescription() {
  let rootElement = document.querySelector(":root");
  rootElement.style.setProperty("--product-main-color", "black");
  rootElement.style.setProperty("--product-secondary-color", "#72F05F");
  rootElement.style.setProperty("--selector-color", "#72F05F");
  rootElement.style.setProperty("--purchase-button", "black");
  rootElement.style.setProperty("--purchase-button-shadow", "#72F05F");
  rootElement.style.setProperty("--custom-menu-background-color", "#F4F4F4");
  rootElement.style.setProperty("--custom-selector-color", "#EFEFEF");
  rootElement.style.setProperty("--custom-selector-border", "#CCCCCC");
  let allProDescriptionDiv = document.querySelectorAll(".pro-shock-show");
  let allFullDescriptionDiv = document.querySelectorAll(".full-shock-show");
  for (let i = 0; i < allProDescriptionDiv.length; i++) {
    if (allProDescriptionDiv[i].classList.contains("product-bundle-item-info") || allProDescriptionDiv[i].classList.contains("bundle-product-item") || allProDescriptionDiv[i].classList.contains("bundle-block-item-info")) {
      allProDescriptionDiv[i].style.display = "flex";
    } else {
      allProDescriptionDiv[i].style.display = "block";
    }
  }
  for (let i = 0; i < allFullDescriptionDiv.length; i++) {
    allFullDescriptionDiv[i].style.display = "none";
  }
  if (document.querySelector("[probundleid]")) {
    document.querySelector("[probundleid]").value = document.querySelector("[probundleid]").getAttribute("probundleid");
    document.querySelector("[proBundleType]").value = document.querySelector("[proBundleType]").getAttribute("proBundleType");
    document.querySelector("[proBundleType]").setAttribute("prevSelected", "Pro-Pack-EU");
    document.querySelector("#bundle-block-item-checkbox").classList.add("checkbox-with-black-icon");
  }
  document.querySelectorAll(".screen-shield-checkbox-small").forEach((element) => {
    element.classList.add("checkbox-with-green-icon");
  });
  document.querySelectorAll(".custom-accessories-input").forEach((element) => {
    element.classList.add("checkbox-with-green-icon");
  });
  document.querySelectorAll("#promotional-product-checbox").forEach((element) => {
    element.classList.add("checkbox-with-black-icon");
  });
}

function showFullShockDescription() {
  let rootElement = document.querySelector(":root");
  rootElement.style.setProperty("--product-main-color", "#8800FF");
  rootElement.style.setProperty("--product-secondary-color", "white");
  rootElement.style.setProperty("--selector-color", "#8800FF");
  rootElement.style.setProperty("--purchase-button", "black");
  rootElement.style.setProperty("--purchase-button-shadow", "#8800FF");
  rootElement.style.setProperty("--custom-menu-background-color", "white");
  rootElement.style.setProperty("--custom-selector-color", "white");
  rootElement.style.setProperty("--custom-selector-border", "black");
  let allProDescriptionDiv = document.querySelectorAll(".pro-shock-show");
  let allFullDescriptionDiv = document.querySelectorAll(".full-shock-show");
  for (let i = 0; i < allProDescriptionDiv.length; i++) {
    allProDescriptionDiv[i].style.display = "none";
  }
  for (let i = 0; i < allFullDescriptionDiv.length; i++) {
    if (allFullDescriptionDiv[i].classList.contains("product-bundle-item-info") || allFullDescriptionDiv[i].classList.contains("bundle-product-item") || allFullDescriptionDiv[i].classList.contains("bundle-block-item-info")) {
      allFullDescriptionDiv[i].style.display = "flex";
    } else {
      allFullDescriptionDiv[i].style.display = "block";
    }
  }
  if (document.querySelector("[fullbundleid]")) {
    document.querySelector("[fullbundleid]").value = document.querySelector("[fullbundleid]").getAttribute("fullbundleid");
    document.querySelector("[fullBundleType]").value = document.querySelector("[fullBundleType]").getAttribute("fullBundleType");
    document.querySelector("[proBundleType]").setAttribute("prevSelected", "Full-Pack-EU");
    document.querySelector("#bundle-block-item-checkbox").classList.remove("checkbox-with-black-icon");
  }
  document.querySelectorAll(".screen-shield-checkbox-small").forEach((element) => {
    element.classList.remove("checkbox-with-green-icon");
  });
  document.querySelectorAll(".custom-accessories-input").forEach((element) => {
    element.classList.remove("checkbox-with-green-icon");
  });
  document.querySelectorAll("#promotional-product-checbox").forEach((element) => {
    element.classList.remove("checkbox-with-black-icon");
  });
}

function changeProductCardPrice(element) {
  let parentElement = element.closest(".product-item");
  if (element.getAttribute("data-item-compare-at-price")) {
    parentElement.querySelector(".price--compare").textContent = element.getAttribute("data-item-compare-at-price");
  }
  if (element.getAttribute("data-item-price")) {
    parentElement.querySelector(".price--highlight").textContent = element.getAttribute("data-item-price");
  }
}

function changeBundleQuantity() {
  if (document.querySelector("#bundle-block-item-checkbox").checked == true) {
    document.querySelector("[inputtype='bundle']").value = 1;
    document.querySelector("[name='properties[bundle]']").outerHTML = document.querySelector("[name='properties[bundle]']").outerHTML.replaceAll("disabledinput", "input");
    document.querySelector("[name='properties[bundle]']").value = document.querySelector("[name='properties[bundle]']").getAttribute("prevSelected");
  } else {
    document.querySelector("[inputtype='bundle']").value = 0;
    document.querySelector("[name='properties[bundle]']").outerHTML = document.querySelector("[name='properties[bundle]']").outerHTML.replaceAll("input", "disabledinput");
    document.querySelector("[name='properties[bundle]']").value = "";
  }
}

window.addEventListener("DOMContentLoaded", (event) => {
  var storedData = sessionStorage.getItem('mystery');
  if (storedData) {
    let parsedData = JSON.parse(storedData);
    for (let key in parsedData) {
      if (document.querySelector(`input[data-id="${key}"]`)) {
          document.querySelector(`input[data-id="${key}"]`).checked = parsedData[key];
          document.querySelector(`input[data-forminputid="${key}"]`).value = parsedData[key] ? 1 : 0;         
      }
    }                               
  }

});

document.addEventListener('variant:added', function(event) {
  var storedData = sessionStorage.getItem('mystery');
    if (storedData) {
      sessionStorage.removeItem('mystery');
    }
});


function handleMysteryHistory(item,value) {
  var storedData = sessionStorage.getItem('mystery'),
      i = 0;
  if (storedData) {
    let parsedData = JSON.parse(storedData);
    for (let key in parsedData) {
      if (key === item) {
        parsedData[key] = value;
        i++;
      }
    }
    if (i > 0) {
        const modifyed = JSON.stringify(parsedData);
        sessionStorage.setItem('mystery', modifyed);      
    } else {
        parsedData[item] = value;
        const updated = JSON.stringify(parsedData);
        sessionStorage.setItem('mystery', updated);
    }
  } else {
    const mystery = {
      [item]: value
    };
    const jsonObject = JSON.stringify(mystery);
    sessionStorage.setItem('mystery', jsonObject);
  }  
}

function changeMysteryBoxQuantity(checkbox,input) {
  if (document.querySelector(checkbox) !== null) {
    if (document.querySelector(checkbox).checked == true) {
      document.querySelector(input).value = 1;
      handleMysteryHistory(document.querySelector(checkbox).dataset.id,true);
    } else {
      document.querySelector(input).value = 0;
      handleMysteryHistory(document.querySelector(checkbox).dataset.id,false);
    }
  }
}

function hotStockRandom(hotStock) {
  if (hotStock) {
      var numbersProductList = hotStock.dataset.hotStock.toString().split(','),
          numbersProductItem = Math.floor(Math.random() * numbersProductList.length);
      hotStock.querySelector('.hot-stock-progress-item span').innerHTML = numbersProductList[numbersProductItem] + '% ';
      hotStock.querySelector('.hot-stock-progress-item').style.width = numbersProductList[numbersProductItem] + '%';
  }
}

function showStikycustomize() {
  let startModal = document.getElementById('data-select-template-modal-start-button');
  if (startModal) {
    let stickyNude = document.getElementById('nude-customize');
    let stickyAtcPrice = document.getElementById('atc-price');
    if (stickyAtcPrice) {
      stickyAtcPrice.style.display = 'none';
    }
    if (stickyNude) {
      stickyNude.style.display = 'block';
      stickyNude.addEventListener('click', (event) => {
        startModal.click();
      })
    }
  }
}


window.addEventListener("DOMContentLoaded", (event) => {
  showStikycustomize();
  hotStockRandom(document.querySelector('.product__hot-stock'));

  if (document.querySelector("#AddToCart"))
    document.querySelector("#AddToCart").style.pointerEvents = "auto";
  if (document.querySelector("#StickyAddToCart"))
    document.querySelector("#StickyAddToCart").style.pointerEvents = "auto";
  let userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;
  let safariAgent = userAgentString.indexOf("Safari") > -1;
  if ((chromeAgent) && (safariAgent)) { 
    safariAgent = false;
  }
  if (safariAgent == true && window.innerWidth < 430) {
    document.querySelectorAll(".variant-name-holder").forEach((element) => { element.style.fontSize = "12px"; element.style.fontWeight = "500"; })
  }
});

function showProductMoreInfo(element) {
  if (element.closest(".screen-shield__option"))
    element.closest(".screen-shield__option").classList.toggle("variant-info__case-show-info--shown");
  if (element.closest(".accessories__option"))
    element.closest(".accessories__option").classList.toggle("variant-info__case-show-info--shown");
  if (element.closest(".block-swatch"))
    element.closest(".block-swatch").classList.toggle("variant-info__case-show-info--shown");
}

async function handleDiscountCode() {
  let discountCodeToAdd = document.querySelector("#phantom-checkout-button")?.getAttribute("discount-code");
  if (discountCodeToAdd)
    await fetch("/discount/" + discountCodeToAdd);
  if (document.querySelector("#mini-cart [form='mini-cart-form']"))
    document.querySelector("#mini-cart [form='mini-cart-form']").click();
  else
    window.location.href = "/checkout";
}
function showCaseType(element) {
  const group = element.closest(".case-type-group");
  const checkedGroup = element.closest(".case-type-group:has(.block-swatch__radio:checked)");
  if (!checkedGroup) {
    group.querySelector('.block-swatch input').click();
  }/*
  if (element.closest(".case-type-group"))
    element.closest(".case-type-group").classList.toggle("show-case-type-group");*/
    /*element.querySelectorAll(".block-swatch").forEach((elem) => elem.classList.toggle("show-case-type-group");*/
}

//new modification
/*
Show the variants with the given index list, remove the 'selected' class from the main case selector, add it to the selected,
then fire click event for the given variant selector id
selectedItem: HTMLElement;
id: string; (id to select);
*/
function selectVariantManually(selectedItem, id) {
  document.querySelector('.magsafe-selector__wrapper .selected').classList.remove('selected');
  selectedItem.classList.add("selected");
  document.getElementById(id)?.click();
}


// Read case type variant data from Liquid-generated JSON
function getMagsafeVariantsData() {
  const scriptTag = document.getElementById('magsafe-variants-data');
  if (!scriptTag) return null;
  try {
    return JSON.parse(scriptTag.textContent);
  } catch (e) {
    return null;
  }
}

// Show/hide .block-swatch-list.case-type.variant-design and .magsafe-heading
// based on whether any MagSafe variant of the selected case type's group is available globally.
// e.g. if selectedCaseType is "Full-Shock" or "Full-Shock MagSafe", checks for any "Full-Shock MagSafe" available.
function updateMagsafeGroupVisibility(selectedCaseType) {
  const caseTypeList = document.querySelector('.block-swatch-list.case-type.variant-design');
  const magSafeTitle = document.querySelector('.magsafe-heading');

  const variants = getMagsafeVariantsData();
  if (!variants) return;

  // Strip " MagSafe" to get the base group name, then look for any available MagSafe variant in that group
  const baseCaseType = selectedCaseType.replace(' MagSafe', '').trim();
  const magsafeCaseType = baseCaseType + ' MagSafe';

  const hasMagsafe = variants.some(function(v) {
    return v.caseType === magsafeCaseType && v.available;
  });

  if (caseTypeList) caseTypeList.style.display = hasMagsafe ? '' : 'none';
  if (magSafeTitle) magSafeTitle.style.display = hasMagsafe ? '' : 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  // Read initial case type from the checked option1 radio on page load
  const initialCaseType = document.querySelector('input[name="option1"]:checked')?.value ?? null;
  if (initialCaseType) updateMagsafeGroupVisibility(initialCaseType);

  const productVariantsEl = document.querySelector('product-variants');
  if (!productVariantsEl) return;

  const formId = productVariantsEl.getAttribute('form-id');
  const form = document.getElementById(formId);
  if (!form) return;

  form.addEventListener('variant:changed', function(event) {
    const variant = event.detail?.variant;
    if (variant) {
      updateMagsafeGroupVisibility(variant.options[0]);
    } else {
      const caseTypeList = document.querySelector('.block-swatch-list.case-type.variant-design');
      const magSafeTitle = document.querySelector('.magsafe-heading');
      if (caseTypeList) caseTypeList.style.display = 'none';
      if (magSafeTitle) magSafeTitle.style.display = 'none';
    }
  });
});

//new modification end

function updateAccessoryCheckedStates() {
  const wrapper = document.querySelector('.accessories__wrapper');
  if (!wrapper) return;
  wrapper.querySelectorAll('.accessories__input').forEach(function(checkbox) {
    const option = checkbox.closest('.accessories__option');
    if (!option) return;
    if (checkbox.checked) {
      option.classList.add('accessory-checked');
    } else {
      option.classList.remove('accessory-checked');
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  updateAccessoryCheckedStates();
  document.addEventListener('click', function(event) {
    if (event.target.matches('.accessories__input')) {
      updateAccessoryCheckedStates();
    }
  });
});

// ─── Bundle Selector ──────────────────────────────────────────────────────────

// When the button is a loader-button, update only its text span so the spinner
// structure (_prepareButton output) is never replaced by innerHTML assignment.
function _setLoaderBtnHtml(btn, html) {
  var textSpan = btn.querySelector('.loader-button__text');
  if (textSpan) {
    textSpan.innerHTML = html;
  } else {
    btn.innerHTML = html;
  }
}
function _getLoaderBtnOrigHtml(btn) {
  var textSpan = btn.querySelector('.loader-button__text');
  return textSpan ? textSpan.innerHTML : btn.innerHTML;
}

function _bsFormatMoney(cents) {
  var format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{amount}}';
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format);
  }
  var amount = (cents / 100).toFixed(2);
  return format
    .replace(/\{\{\s*amount\s*\}\}/g, amount)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
}

function updateBundleSelectorPrices(priceCents, comparePriceCents) {
  var block = document.getElementById('bundle-selector-block');
  if (!block) return;

  // Main variant: compare_at_price as old price component, current price as new price component
  var mainOldCents = (comparePriceCents > 0) ? comparePriceCents : priceCents;
  var mainNewCents = priceCents;

  // Bundle product prices (Shopify stores prices in cents as integers)
  function bundleAttr(attr) {
    return parseInt(block.getAttribute(attr) || '0', 10) || 0;
  }
  var b1Price   = bundleAttr('data-bundle1-price');
  var b1Compare = bundleAttr('data-bundle1-compare-price');
  var b2Price   = bundleAttr('data-bundle2-price');
  var b2Compare = bundleAttr('data-bundle2-compare-price');

  // Bundle 1: main variant compare_at + bundle product 1 compare_at = old price
  //           main variant price       + bundle product 1 price       = new price
  var oldPrice1 = mainOldCents + (b1Compare > 0 ? b1Compare : b1Price);
  var newPrice1 = mainNewCents + b1Price;

  // Bundle 2: same logic with bundle product 2
  var oldPrice2 = mainOldCents + (b2Compare > 0 ? b2Compare : b2Price);
  var newPrice2 = mainNewCents + b2Price;

  // Update price spans
  function setPrice(id, cents) {
    var el = document.getElementById(id);
    if (el) el.textContent = cents > 0 ? _bsFormatMoney(cents) : '';
  }
  setPrice('bundle-selector-price-new-1', newPrice1);
  setPrice('bundle-selector-price-old-1', oldPrice1);
  setPrice('bundle-selector-price-new-2', newPrice2);
  setPrice('bundle-selector-price-old-2', oldPrice2);

  // Cache raw cent values so updateBundleSelectorInputs can compute discount % on radio change
  block.setAttribute('data-computed-new-1', newPrice1);
  block.setAttribute('data-computed-old-1', oldPrice1);
  block.setAttribute('data-computed-new-2', newPrice2);
  block.setAttribute('data-computed-old-2', oldPrice2);

  // Populate <bundle-discount> elements inside each badge with the calculated percentage
  function setBadgeDiscount(idx, newP, oldP) {
    var pct = (oldP > 0 && newP < oldP) ? Math.round((1 - newP / oldP) * 100) : 0;
    var pctText = pct > 0 ? String(pct) + '%' : '';
    var badge = document.getElementById('bundle-selector-badge-' + idx);
    if (badge) {
      badge.querySelectorAll('bundle-discount').forEach(function(el) {
        el.textContent = pctText;
      });
    }
    var pricingBadge = document.getElementById('bundle-selector-pricing-badge-' + idx);
    if (pricingBadge) {
      pricingBadge.querySelectorAll('bundle-discount').forEach(function(el) {
        el.textContent = pctText;
      });
    }
  }
  setBadgeDiscount(1, newPrice1, oldPrice1);
  setBadgeDiscount(2, newPrice2, oldPrice2);

  // Placeholder card (index 0): main variant's own price vs compare-at
  setPrice('bundle-selector-price-new-0', priceCents);
  setPrice('bundle-selector-price-old-0', comparePriceCents > priceCents ? comparePriceCents : 0);
  setBadgeDiscount(0, priceCents, comparePriceCents);

  // Update <bundle-new-price> and <bundle-old-price> placeholder elements
  // (can be used inside bundle_selector_below_price_1 / _2 settings)
  [
    { idx: 1, newPrice: newPrice1, oldPrice: oldPrice1 },
    { idx: 2, newPrice: newPrice2, oldPrice: oldPrice2 }
  ].forEach(function(bundle) {
    var label = document.querySelector('label[for="bundle-radio-' + bundle.idx + '"]');
    if (!label) return;
    label.querySelectorAll('bundle-new-price').forEach(function(el) {
      el.textContent = bundle.newPrice > 0 ? _bsFormatMoney(bundle.newPrice) : '';
    });
    label.querySelectorAll('bundle-old-price').forEach(function(el) {
      el.textContent = bundle.oldPrice > 0 ? _bsFormatMoney(bundle.oldPrice) : '';
    });
    label.querySelectorAll('bundle-price-difference').forEach(function(el) {
      var diff = bundle.oldPrice - bundle.newPrice;
      el.textContent = diff > 0 ? _bsFormatMoney(diff) : '';
    });
  });

  // Update <phone-price> and <product-current-price> elements
  var formatted = _bsFormatMoney(mainNewCents);
  block.querySelectorAll('phone-price').forEach(function(el) {
    el.textContent = formatted;
  });
  block.querySelectorAll('product-current-price').forEach(function(el) {
    el.textContent = formatted;
  });

  // Also refresh the ATC button text when prices recalculate (variant change)
  // Re-stamp from the raw template and substitute placeholders with updated prices
  var atcBtnEl = document.getElementById('AddToCart');
  if (atcBtnEl && !atcBtnEl.disabled) {
    var _checkedRadio = block.querySelector('.bundle-selector__radio:checked');
    if (_checkedRadio) {
      var _bi = _checkedRadio.value;
      var _tplEl = document.getElementById('bundle-atc-text-' + _bi);
      if (_tplEl) {
        var _rawText = _tplEl.textContent;
        var _newP = _bi === '1' ? newPrice1 : (_bi === '2' ? newPrice2 : 0);
        var _oldP = _bi === '1' ? oldPrice1 : (_bi === '2' ? oldPrice2 : 0);
        var _newPF = _newP > 0 ? _bsFormatMoney(_newP) : '';
        var _oldPF = _oldP > 0 ? _bsFormatMoney(_oldP) : '';
        var _discPct = (_oldP > 0 && _newP < _oldP) ? String(Math.round((1 - _newP / _oldP) * 100)) + '%' : '';
        var _diffF = (_oldP > _newP) ? _bsFormatMoney(_oldP - _newP) : '';
        var _stamped = _rawText
          .replace(/<bundle-new-price\s*\/?>/gi, _newPF).replace(/<\/bundle-new-price>/gi, '')
          .replace(/<bundle-old-price\s*\/?>/gi, _oldPF).replace(/<\/bundle-old-price>/gi, '')
          .replace(/<bundle-discount\s*\/?>/gi, _discPct).replace(/<\/bundle-discount>/gi, '')
          .replace(/<bundle-price-difference\s*\/?>/gi, _diffF).replace(/<\/bundle-price-difference>/gi, '');
        if (!atcBtnEl.hasAttribute('data-atc-original-html')) {
          atcBtnEl.setAttribute('data-atc-original-html', _getLoaderBtnOrigHtml(atcBtnEl));
        }
        _setLoaderBtnHtml(atcBtnEl, _stamped);
        var _stickyBtnEl = document.getElementById('StickyAddToCart');
        if (_stickyBtnEl && !_stickyBtnEl.disabled) {
          if (!_stickyBtnEl.hasAttribute('data-atc-original-html')) {
            _stickyBtnEl.setAttribute('data-atc-original-html', _getLoaderBtnOrigHtml(_stickyBtnEl));
          }
          _setLoaderBtnHtml(_stickyBtnEl, _stamped);
        }
      }
    }
  }
}

function updateBundleSelectorConditionalElements() {
  var block = document.getElementById('bundle-selector-block');
  if (!block) return;
  var inPro  = block.getAttribute('data-in-pro')  === 'true';
  var inNano = block.getAttribute('data-in-nano') === 'true';

  block.querySelectorAll('if-proshield').forEach(function(el) {
    el.style.display = inPro ? '' : 'none';
  });
  block.querySelectorAll('if-nanoglass').forEach(function(el) {
    el.style.display = inNano ? '' : 'none';
  });

  // Hide any <li> whose text content is now entirely inside hidden elements
  block.querySelectorAll('.bundle-selector__usp-item').forEach(function(li) {
    var textSpan = li.querySelector('span:not(.bundle-selector__usp-icon)');
    if (!textSpan) return;
    var hasVisible = false;
    textSpan.childNodes.forEach(function(node) {
      if (hasVisible) return;
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.trim()) hasVisible = true;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        var tag = node.tagName.toLowerCase();
        // phone-price is always considered visible (price is set by JS, not inline HTML)
        if (tag === 'phone-price') {
          hasVisible = true;
        } else if (node.style.display !== 'none' && node.textContent.trim()) {
          hasVisible = true;
        }
      }
    });
    li.style.display = hasVisible ? '' : 'none';
  });
}

function updateBundleSelectorInputs(radio) {
  var bundleIndex = radio.value;
  var idInput           = document.getElementById('bundle-selector-id');
  var qtyInput          = document.getElementById('bundle-selector-quantity');
  var propInput         = document.getElementById('bundle-selector-prop');
  var mainEpochInput    = document.getElementById('bundle-selector-main-epoch');
  var bundleContentInput = document.getElementById('bundle-selector-bundle-content');
  var caseContentInput   = document.getElementById('bundle-selector-case-content');

  if (!idInput || !qtyInput) return;

  // Update Add to Cart button text
  var block = document.getElementById('bundle-selector-block');
  var atcBtn = document.getElementById('AddToCart');
  if (block && atcBtn && !atcBtn.disabled) {
    var _tpl1 = document.getElementById('bundle-atc-text-1');
    var _tpl2 = document.getElementById('bundle-atc-text-2');
    var atcText1 = _tpl1 ? _tpl1.textContent : '';
    var atcText2 = _tpl2 ? _tpl2.textContent : '';
    var customText = bundleIndex === '1' ? atcText1 : (bundleIndex === '2' ? atcText2 : '');
    if (customText) {
      // Store original inner HTML the first time we override it
      if (!atcBtn.hasAttribute('data-atc-original-html')) {
        atcBtn.setAttribute('data-atc-original-html', _getLoaderBtnOrigHtml(atcBtn));
      }
      // Replace <bundle-new-price/> and <bundle-old-price/> placeholder tags with the actual
      // price strings BEFORE setting innerHTML — so the browser never parses them as open tags
      // that swallow surrounding text.
      var _priceNewEl = document.getElementById('bundle-selector-price-new-' + bundleIndex);
      var _priceOldEl = document.getElementById('bundle-selector-price-old-' + bundleIndex);
      var _priceNew = _priceNewEl ? _priceNewEl.textContent : '';
      var _priceOld = _priceOldEl ? _priceOldEl.textContent : '';
      var _computedNew = parseInt(block.getAttribute('data-computed-new-' + bundleIndex) || '0', 10);
      var _computedOld = parseInt(block.getAttribute('data-computed-old-' + bundleIndex) || '0', 10);
      var _discountPct = (_computedOld > 0 && _computedNew < _computedOld) ? String(Math.round((1 - _computedNew / _computedOld) * 100)) + '%' : '';
      var _priceDiffF = (_computedOld > _computedNew) ? _bsFormatMoney(_computedOld - _computedNew) : '';
      var _processedText = customText
        .replace(/<bundle-new-price\s*\/?>/gi, _priceNew).replace(/<\/bundle-new-price>/gi, '')
        .replace(/<bundle-old-price\s*\/?>/gi, _priceOld).replace(/<\/bundle-old-price>/gi, '')
        .replace(/<bundle-discount\s*\/?>/gi, _discountPct).replace(/<\/bundle-discount>/gi, '')
        .replace(/<bundle-price-difference\s*\/?>/gi, _priceDiffF).replace(/<\/bundle-price-difference>/gi, '');
      _setLoaderBtnHtml(atcBtn, _processedText);
      var _stickyBtn = document.getElementById('StickyAddToCart');
      if (_stickyBtn && !_stickyBtn.disabled) {
        if (!_stickyBtn.hasAttribute('data-atc-original-html')) {
          _stickyBtn.setAttribute('data-atc-original-html', _getLoaderBtnOrigHtml(_stickyBtn));
        }
        _setLoaderBtnHtml(_stickyBtn, _processedText);
      }
    } else {
      // Restore original HTML when placeholder or no custom text
      var originalHtml = atcBtn.getAttribute('data-atc-original-html');
      if (originalHtml) {
        _setLoaderBtnHtml(atcBtn, originalHtml);
      }
      var _stickyBtnRestore = document.getElementById('StickyAddToCart');
      if (_stickyBtnRestore) {
        var _stickyOrigHtml = _stickyBtnRestore.getAttribute('data-atc-original-html');
        if (_stickyOrigHtml) {
          _setLoaderBtnHtml(_stickyBtnRestore, _stickyOrigHtml);
        }
      }
    }
  }

  if (bundleIndex === '0') {
    // Placeholder — no bundle added to cart; suppress the main-product epoch too
    qtyInput.value = '0';
    if (propInput)          propInput.disabled          = true;
    if (mainEpochInput)     mainEpochInput.disabled     = true;
    if (bundleContentInput) bundleContentInput.disabled = true;
    if (caseContentInput)   caseContentInput.disabled   = true;
    // Immediately submit — trigger a click on the ATC button (skip if sold out or card mode)
    var atcBtnPlaceholder = document.getElementById('AddToCart');
    var noPlaceholderAtc = block && block.hasAttribute('data-no-placeholder-atc');
    if (atcBtnPlaceholder && !atcBtnPlaceholder.disabled && !noPlaceholderAtc) {
      atcBtnPlaceholder.click();
    }
  } else {
    var bundleId = idInput.getAttribute('data-bundle' + bundleIndex + '-id');
    if (bundleId) idInput.value = bundleId;
    qtyInput.value = '1';

    if (propInput) {
      var propName  = propInput.getAttribute('data-bundle' + bundleIndex + '-name');
      var propValue = propInput.getAttribute('data-bundle' + bundleIndex + '-value');
      var itemIndex = propInput.getAttribute('data-item-index');

      if (propName && propName.trim() !== '') {
        propInput.name     = 'items[' + itemIndex + '][properties][' + propName + ']';
        propInput.value    = propValue || '';
        propInput.disabled = false;
      } else {
        propInput.disabled = true;
      }
    }

    if (bundleContentInput) {
      bundleContentInput.value    = bundleContentInput.getAttribute('data-bundle' + bundleIndex + '-value') || '';
      bundleContentInput.disabled = false;
    }
    if (caseContentInput) {
      caseContentInput.value    = 'case_p';
      caseContentInput.disabled = false;
    }
    if (mainEpochInput) mainEpochInput.disabled = false;
  }
}

function initBundleSelector() {
  var block = document.getElementById('bundle-selector-block');
  if (!block) return;

  var radios = block.querySelectorAll('.bundle-selector__radio');
  if (!radios.length) return;

  // Initialise hidden inputs to match the default checked radio
  var checkedRadio = block.querySelector('.bundle-selector__radio:checked');
  if (checkedRadio) updateBundleSelectorInputs(checkedRadio);

  // Populate any <phone-price> placeholders with the initial variant price
  var initialPrice        = parseInt(block.getAttribute('data-product-price'), 10);
  var initialComparePrice = parseInt(block.getAttribute('data-product-compare-price'), 10);
  if (!isNaN(initialPrice)) updateBundleSelectorPrices(initialPrice, initialComparePrice);
  updateBundleSelectorConditionalElements();

  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      updateBundleSelectorInputs(this);
    });
  });

  // Stamp a fresh epoch onto both the bundle item and the main product
  // using a document-level capture-phase listener on 'submit'.
  // Capture phase fires top-down (document → form), so this runs before
  // the theme's form-level submit listener regardless of registration order
  // AND regardless of whether the submit was triggered by a user click,
  // a programmatic .click(), the sticky button, or the alternative button.
  var qtyInput = document.getElementById('bundle-selector-quantity');
  if (qtyInput) {
    var form = qtyInput.closest('form');
    if (form) {
      document.addEventListener('submit', function(e) {
        if (e.target !== form) return;
        if (qtyInput.value === '0') return;
        var epoch = Date.now().toString();
        var bundleEpoch = document.getElementById('bundle-selector-epoch');
        var mainEpoch   = document.getElementById('bundle-selector-main-epoch');
        if (bundleEpoch) bundleEpoch.value = epoch;
        if (mainEpoch)   mainEpoch.value   = epoch;
        startBundleAtcLoading();
      }, true); // capture: true — fires before any target-phase listener on form
    }
  }
}

function startBundleAtcLoading() {
  var atcBtn = document.getElementById('AddToCart');
  if (!atcBtn) return;
  var sticky = document.getElementById('StickyAddToCart');
  var _done  = false;

  function stopLoading() {
    if (_done) return;
    _done = true;
    observer.disconnect();
    clearTimeout(fallback);
    atcBtn.removeAttribute('disabled');
    atcBtn.removeAttribute('aria-busy');
    if (sticky) {
      sticky.removeAttribute('disabled');
      sticky.removeAttribute('aria-busy');
    }
  }

  // Set aria-busy to trigger the loader-button spinner animation, then lock the button.
  // aria-busy is intentionally set only once here; the theme will clear it after its
  // /cart/add.js fetch. We do NOT re-apply it in the observer to avoid clashing with
  // the loader-button animation state machine (_endTransition vs _startTransition race).
  atcBtn.setAttribute('aria-busy', 'true');
  atcBtn.setAttribute('disabled', 'disabled');
  if (sticky) {
    sticky.setAttribute('aria-busy', 'true');
    sticky.setAttribute('disabled', 'disabled');
  }

  // Re-apply disabled only when the theme removes it after its fetch resolves,
  // keeping the button locked until cart:updated fires.
  var observer = new MutationObserver(function() {
    if (_done) { observer.disconnect(); return; }
    if (!atcBtn.hasAttribute('disabled')) {
      atcBtn.setAttribute('disabled', 'disabled');
    }
    if (sticky && !sticky.hasAttribute('disabled')) {
      sticky.setAttribute('disabled', 'disabled');
    }
  });
  observer.observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });

  // Release once the cart update is confirmed
  document.documentElement.addEventListener('cart:updated', function onBundleCartUpdated() {
    document.documentElement.removeEventListener('cart:updated', onBundleCartUpdated);
    stopLoading();
  });

  // Safety fallback: release after 8 s if cart:updated never fires (e.g. network error)
  var fallback = setTimeout(stopLoading, 8000);
}

// Keep caseSku and <phone-price> elements in sync when the variant changes
function updateUSPBlocks(variantTitle) {
  var title = (variantTitle || '').toLowerCase();
  var isFullShock = title.indexOf('full-shock') !== -1;
  var isProShock  = title.indexOf('pro-shock')  !== -1;
  document.querySelectorAll('[data-usp-block-el]').forEach(function(block) {
    var defaultList   = block.querySelector('[data-usp-list="default"]');
    var fullShockList = block.querySelector('[data-usp-list="full-shock"]');
    var proShockList  = block.querySelector('[data-usp-list="pro-shock"]');
    var showList;
    if (isProShock && proShockList)       showList = proShockList;
    else if (isFullShock && fullShockList) showList = fullShockList;
    else                                   showList = defaultList;
    if (defaultList)   defaultList.style.display   = showList === defaultList   ? '' : 'none';
    if (fullShockList) fullShockList.style.display  = showList === fullShockList ? '' : 'none';
    if (proShockList)  proShockList.style.display   = showList === proShockList  ? '' : 'none';
  });
}

function updatePostTitleCaseType(variantTitle) {
  var title = (variantTitle || '').toLowerCase();
  var isFullShock = title.indexOf('full-shock') !== -1;
  var isProShock  = title.indexOf('pro-shock')  !== -1;
  document.querySelectorAll('[data-post-title-el] full-shock-only').forEach(function(el) {
    el.style.display = isFullShock ? 'inline' : 'none';
  });
  document.querySelectorAll('[data-post-title-el] pro-shock-only').forEach(function(el) {
    el.style.display = isProShock ? 'inline' : 'none';
  });
}

function updateStickyFormVisibility(options) {
  var stickyForm = document.querySelector('product-sticky-form');
  if (!stickyForm) return;
  var opts = (options || []).map(function(o) { return (o || '').toLowerCase(); });
  var hide = opts.some(function(o) { return o === 'full-shock'; }) &&
             opts.some(function(o) { return o === 'black'; });
  stickyForm.style.display = hide ? 'none' : '';
}

document.addEventListener('variant:changed', function(event) {
  var variant     = event.detail && event.detail.variant;

  // Tag-bundle addon: update epoch when variant changes to ensure bundle sync uses correct variant IDs
  var addonIdInput = document.getElementById('tag-bundle-addon-id');
  if (addonIdInput && variant && variant.id) {
    // Recalculate the epoch with the new variant ID
    var newMainId = String(variant.id);
    var addonId = addonIdInput.value;
    var newEpoch = newMainId + '_' + addonId;
    
    var addonEpochInput = document.getElementById('tag-bundle-addon-epoch');
    var mainEpochInput = document.getElementById('tag-bundle-main-epoch');
    
    if (addonEpochInput) addonEpochInput.value = newEpoch;
    if (mainEpochInput) mainEpochInput.value = newEpoch;
  }

  // Tag-bundle addon: hide ATC form for Full-Shock + Black, show for all other variants
  var addonForm = document.querySelector('[data-tag-bundle-addon-form]');
  if (addonForm) {
    var isFullShockBlack = false;
    if (variant && variant.options) {
      var opts = variant.options.map(function(o) { return (o || '').toLowerCase(); });
      isFullShockBlack = opts.some(function(o) { return o === 'full-shock'; }) &&
                         opts.some(function(o) { return o === 'black'; });
    }
    addonForm.classList.toggle('tag-bundle-addon-form--hidden', isFullShockBlack);
  }

  updateStickyFormVisibility(variant && variant.options);

  var caseSkuInput = document.getElementById('bundle-selector-case-sku');
  if (caseSkuInput && variant && variant.sku) {
    caseSkuInput.value = variant.sku;
  }
  if (variant && variant.price != null) {
    updateBundleSelectorPrices(variant.price, variant.compare_at_price);
  }
  if (variant && variant.title) {
    updatePostTitleCaseType(variant.title);
    updateUSPBlocks(variant.title);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  initBundleSelector();
  var postTitleEl = document.querySelector('[data-post-title-el]');
  if (postTitleEl) {
    updatePostTitleCaseType(postTitleEl.getAttribute('data-initial-variant') || '');
  }
  // Apply sticky form visibility based on the initially selected variant
  var initialOptions = Array.from(document.querySelectorAll('input[name^="option"]:checked')).map(function(el) { return el.value; });
  updateStickyFormVisibility(initialOptions);
  var uspBlock = document.querySelector('[data-usp-block-el]');
  if (uspBlock) {
    var initVariant = document.querySelector('[data-post-title-el]');
    // Use the variant title embedded in the page's initial CSS comment or fall back
    // to reading it from the first USP list that is currently visible
    var visibleList = uspBlock.querySelector('[data-usp-list]:not([style*="display:none"])');
    // USP initial state is already correctly set by Liquid inline styles,
    // so no extra JS call needed on load — only hook up variant:changed above.
  }
});

// ─── Mini-cart: keep bundle-selector pairs visually grouped ──────────────────
// After every cart re-render, move each bundle add-on immediately after its
// paired case (matched by _bundleEpoch) so the shared border CSS lines up.

(function () {
  function groupBundleSelectorCartItems() {
    var form = document.getElementById('mini-cart-form');
    if (!form) return;

    var mains = form.querySelectorAll('.bundle-selector-main[data-bundle-epoch]');
    mains.forEach(function (main) {
      var epoch = main.getAttribute('data-bundle-epoch');
      var addon = form.querySelector('.bundle-selector-addon[data-bundle-epoch="' + epoch + '"]');
      if (addon && main.nextElementSibling !== addon) {
        main.after(addon);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', groupBundleSelectorCartItems);

  // Re-run after the theme re-renders the mini-cart section
  var miniCart = document.getElementById('mini-cart');
  if (miniCart) {
    new MutationObserver(function (mutations) {
      var relevantChange = mutations.some(function (m) {
        return m.type === 'childList' && m.addedNodes.length > 0;
      });
      if (relevantChange) groupBundleSelectorCartItems();
    }).observe(miniCart, { childList: true, subtree: true });
  }
}());

// ─── Bundle Epoch Cart Sync ───────────────────────────────────────────────────
// Items sharing the same _bundleEpoch property are kept in sync:
// any quantity change or removal applied to one is mirrored to all partners.
//
// Two complementary phases run on every cart:updated:
//
//   Phase 1 — Reactive diff: detects what changed vs. the previous snapshot and
//   mirrors that change to the partner item(s).
//
//   Phase 2 — Proactive audit: inspects the live cart independently of any diff.
//   Catches mismatches that slipped through the reactive path (stale snapshot,
//   rapid mutations while the sync lock was held, cross-tab/session edits, etc.).
//   • 2+ paid items with the same epoch but different quantities → reduce all to min.
//   • Exactly 1 paid item with an epoch and no partner at all → remove it (qty 0).

(function () {
  'use strict';

  var _syncLock  = false;
  var _prevItems = null; // snapshot of cart.items at the time of the last update

  function epochOf(item) {
    return item.properties && item.properties['_bundleEpoch'] || null;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function changeLineItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  // ── Phase 1: Reactive diff ──────────────────────────────────────────────────
  // Compares current cart to the previous snapshot and returns [{key, quantity}]
  // fixes for any partner items that are out of step with a detected change.
  function detectReactiveFixes(currentItems, prev) {
    if (!prev || !prev.length) return [];

    var changedEpoch = null;
    var changedKey   = null;
    var targetQty    = null;

    // 1. Quantity changed (item still present but different qty)
    currentItems.forEach(function (item) {
      var epoch = epochOf(item);
      if (!epoch || changedEpoch) return;
      var prevItem = prev.find(function (p) { return p.key === item.key; });
      if (prevItem && prevItem.quantity !== item.quantity) {
        changedEpoch = epoch;
        changedKey   = item.key;
        targetQty    = item.quantity;
      }
    });

    // 2. Item removed (was in prev, gone now)
    if (!changedEpoch) {
      prev.forEach(function (prevItem) {
        var epoch = epochOf(prevItem);
        if (!epoch || changedEpoch) return;
        var still = currentItems.find(function (i) { return i.key === prevItem.key; });
        if (!still) {
          // Item is gone — but check whether Shopify merely re-keyed it (assigned a new
          // line-item key while keeping its properties, which happens when automatic
          // discounts / Shopify Functions touch the item on a cart mutation).
          // A re-key shows up as: an item with the same epoch that did NOT exist in prev.
          var isRekeyed = currentItems.some(function (i) {
            return epochOf(i) === epoch &&
                   !prev.find(function (p) { return p.key === i.key; });
          });
          if (isRekeyed) return; // replaced in-place — not a true deletion, skip sync
          changedEpoch = epoch;
          changedKey   = prevItem.key;
          targetQty    = 0;
        }
      });
    }

    if (!changedEpoch || targetQty === null) return [];

    // Find partner items that are out of step
    return currentItems
      .filter(function (item) {
        return item.key !== changedKey &&
               epochOf(item) === changedEpoch &&
               item.final_price !== 0 &&
               item.quantity !== targetQty;
      })
      .map(function (item) { return { key: item.key, quantity: targetQty }; });
  }

  // ── Phase 2: Proactive audit ────────────────────────────────────────────────
  // Scans the live cart holistically and returns [{key, quantity}] fixes for any
  // epoch group that is already inconsistent, regardless of how it got that way.
  function detectAuditFixes(currentItems) {
    var byEpoch = {};
    currentItems.forEach(function (item) {
      var epoch = epochOf(item);
      if (!epoch) return;
      if (!byEpoch[epoch]) byEpoch[epoch] = [];
      byEpoch[epoch].push(item);
    });

    var toFix = [];
    Object.keys(byEpoch).forEach(function (epoch) {
      var allInGroup  = byEpoch[epoch];
      var paidInGroup = allInGroup.filter(function (i) { return i.final_price !== 0; });

      if (paidInGroup.length === 0) return;

      if (allInGroup.length === 1 && paidInGroup.length === 1) {
        // Truly orphaned — no partner whatsoever (not even a free/discounted one)
        toFix.push({ key: paidInGroup[0].key, quantity: 0 });
        return;
      }

      if (paidInGroup.length < 2) return; // only 1 paid item but a free partner exists — leave alone

      // 2+ paid items in group: sync all down to the minimum quantity
      var minQty = paidInGroup.reduce(function (m, i) { return Math.min(m, i.quantity); }, Infinity);
      paidInGroup.forEach(function (item) {
        if (item.quantity !== minQty) {
          toFix.push({ key: item.key, quantity: minQty });
        }
      });
    });

    return toFix;
  }

  async function syncEpochPartners(updatedCart) {
    var currentItems = updatedCart.items || [];
    var prev = _prevItems;

    // Always update the snapshot first, even when locked, so the diff never
    // runs against a stale baseline after the lock is released.
    _prevItems = currentItems;

    if (_syncLock) return;

    // Phase 1: what changed from the previous snapshot?
    var reactiveFixes = detectReactiveFixes(currentItems, prev);

    // Phase 2: is the live cart already inconsistent, regardless of how?
    var reactiveKeys = reactiveFixes.map(function (x) { return x.key; });
    var auditFixes   = detectAuditFixes(currentItems).filter(function (x) {
      return reactiveKeys.indexOf(x.key) === -1; // avoid double-patching same key
    });

    var allFixes = reactiveFixes.concat(auditFixes);
    if (!allFixes.length) return;

    // ── Apply all fixes ─────────────────────────────────────────────────────
    _syncLock = true;
    try {
      var lastCart = null;
      for (var i = 0; i < allFixes.length; i++) {
        lastCart = await changeLineItem(allFixes[i].key, allFixes[i].quantity);
      }
      if (lastCart) {
        _prevItems = lastCart.items || [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: lastCart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: lastCart, replacementDelay: 750 }
        }));
      }
    } finally {
      _syncLock = false;
    }
  }

  // Seed the initial snapshot and run an immediate audit to catch any
  // pre-existing mismatches from a previous session or browser tab.
  fetchCart().then(function (cart) {
    _prevItems = cart.items || [];
    syncEpochPartners(cart);
  });

  // Hook into every cart update the theme fires.
  // Note: _syncLock is NOT checked here — syncEpochPartners always updates
  // _prevItems first (before its own lock check) so the snapshot stays current
  // even for events that arrive while a sync is already in flight.
  document.documentElement.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    syncEpochPartners(cart);
  });
}());

// ─── Tag-Based Bundle: standalone addon removal ─────────────────────────────
{
  const { tagBundleHideAddonSelling, tagBundleAddonPrefix } = window.themeVariables?.settings ?? {};

  if (tagBundleHideAddonSelling && tagBundleAddonPrefix) {
    const isFullShockBlackVariant = (item) => {
      const opts = (item.options_with_values ?? []).map((o) => ({
        name: (o.name ?? '').toLowerCase(),
        value: (o.value ?? '').toLowerCase(),
      }));
      return (
        opts.some((o) => o.name === 'case type' && o.value === 'full-shock') &&
        opts.some((o) => o.name === 'color' && o.value === 'black')
      );
    };

    const isStandaloneAddon = (item) => {
      if (!item.handle?.startsWith(tagBundleAddonPrefix + '-')) return false;
      if (!isFullShockBlackVariant(item)) return false;
      return item.properties?.['_tagBundleAddon'] !== '1';
    };

    const dispatchCartEvents = (cart) => {
      for (const name of ['cart:updated', 'cart:refresh']) {
        document.documentElement.dispatchEvent(
          new CustomEvent(name, { bubbles: true, detail: { cart, replacementDelay: 750 } })
        );
      }
    };

    const removeStandaloneAddons = async (cart) => {
      const items = cart.items ?? [];
      const standaloneAddons = items.filter(isStandaloneAddon);
      if (!standaloneAddons.length) return;

      // Collect SKUs of the standalone addons being removed
      const addonSkus = new Set(standaloneAddons.map((item) => item.sku).filter(Boolean));

      // Also remove any mystery-gift-1 items whose caseSku matches one of those addon SKUs
      const mysteryGiftsToRemove = items.filter(
        (item) =>
          item.handle === 'mystery-gift-1' &&
          addonSkus.has(item.properties?.['caseSku'])
      );

      const toRemove = [...standaloneAddons, ...mysteryGiftsToRemove];

      let lastCart;
      for (const item of toRemove) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });
        lastCart = await res.json();
      }

      if (lastCart) dispatchCartEvents(lastCart);
    };

    // Run on page load
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then(removeStandaloneAddons);

    // Run on every cart update
    document.documentElement.addEventListener('cart:updated', ({ detail }) => {
      if (detail?.cart) removeStandaloneAddons(detail.cart);
    });
  }
}

// ─── Tag-Based Bundle: epoch stamping ───────────────────────────────────────
const initTagBundle = () => {
  const addonEpoch = document.getElementById('tag-bundle-addon-epoch');
  if (!addonEpoch) return;
  const mainEpoch = document.getElementById('tag-bundle-main-epoch');
  const form = addonEpoch.closest('form');
  if (!form) return;

  document.addEventListener('submit', (e) => {
    if (e.target !== form) return;
    const addonQty = document.getElementById('tag-bundle-addon-quantity');
    if (addonQty?.value === '0') return;

    let epoch = addonEpoch.value;
    const bsMainEpoch = document.getElementById('bundle-selector-main-epoch');
    if (bsMainEpoch?.value) {
      epoch = bsMainEpoch.value;
      addonEpoch.value = epoch;
    }
    if (mainEpoch) mainEpoch.value = epoch;
  }, true);
};

document.addEventListener('DOMContentLoaded', initTagBundle);

// ─── Cart Countdown custom element ───────────────────────────────────────────

class CartCountdown extends HTMLElement {
  connectedCallback() {
    var wrapper = this.closest('[data-minutes]');
    this._totalSeconds = parseInt(wrapper ? wrapper.dataset.minutes : 10, 10) * 60;
    this._remaining = this._totalSeconds;
    this._render();
    this._start();

    // Reset every time the cart drawer opens
    var drawer = document.getElementById('mini-cart');
    if (drawer) {
      drawer.addEventListener('openable-element:open', this._onDrawerOpen.bind(this));
    }
  }

  disconnectedCallback() {
    clearInterval(this._interval);
    var drawer = document.getElementById('mini-cart');
    if (drawer) {
      drawer.removeEventListener('openable-element:open', this._onDrawerOpen.bind(this));
    }
  }

  _onDrawerOpen() {
    this._remaining = this._totalSeconds;
    this._render();
    this._start();
  }

  _start() {
    clearInterval(this._interval);
    this._interval = setInterval(function () {
      this._remaining = Math.max(0, this._remaining - 1);
      this._render();
      if (this._remaining === 0) clearInterval(this._interval);
    }.bind(this), 1000);
  }

  _render() {
    var m = Math.floor(this._remaining / 60);
    var s = this._remaining % 60;
    this.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
}

if (!customElements.get('cart-countdown')) {
  customElements.define('cart-countdown', CartCountdown);
}

// ─── Global Cart Update Listener ───────────────────────────────────────────
// Ensures header cart count updates whenever cart:updated event fires
document.addEventListener('cart:updated', function(event) {
  if (event.detail && event.detail.cart && event.detail.cart.item_count !== undefined) {
    const itemCount = event.detail.cart.item_count;
    
    // Update all cart count elements (fallback for header)
    const cartCountElements = document.querySelectorAll('.header__cart-count, [data-cart-count]');
    cartCountElements.forEach(el => {
      el.textContent = itemCount;
      // Remove visually-hidden class when cart has items
      if (itemCount > 0) {
        el.classList.remove('visually-hidden');
      } else {
        el.classList.add('visually-hidden');
      }
    });
    
    console.log('Global cart update: item count =', itemCount);
  }
});